import { render, staticRenderFns } from "./statistics_event.vue?vue&type=template&id=68d21634&scoped=true&"
import script from "./statistics_event.vue?vue&type=script&lang=js&"
export * from "./statistics_event.vue?vue&type=script&lang=js&"
import style0 from "./statistics_event.vue?vue&type=style&index=0&id=68d21634&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d21634",
  null
  
)

export default component.exports